module.exports = __webpack_public_path__ + "static/media/icon_close.3dd2f874.svg";